import axios, { CancelToken } from 'axios';

import { IFonteSaldoDeContas } from '../../../../pages/SaldoDeContas/SolicitacoesDeAtivacao/interfaces';
import { IFonteACadastrar } from '../../../../pages/SaldoDeContas/FontesACadastrar/interfaces';

import { GATEWAY_API_URL } from "../../../request/urls";
import { getToken } from "../../../token";

class FontesACadastrarService {
    async getQuantidadeFontesACadastrar(): Promise<number> {

        const { data } = await axios.get(`${GATEWAY_API_URL}/saldo-empenhos/fonte/qtde-a-cadastrar`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
        });

        return data.quantidade_a_cadastrar;
    }

    async getFontesACadastrar(signal?: CancelToken): Promise<IFonteACadastrar[]> {

        const { data } = await axios.get(`${GATEWAY_API_URL}/saldo-empenhos/fonte/a-cadastrar`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data.fontesACadastrar;
    }

    async createFonte({
        numero,
        descricao,
        categoriaId,
        orgaoId,
    }: {
        numero: string,
        descricao: string,
        categoriaId: number,
        orgaoId: number,
    }): Promise<IFonteSaldoDeContas> {

        const { data } = await axios.post(
            `${GATEWAY_API_URL}/saldo-empenhos/fonte`,
            {
                orgaoId,
                descricao,
                numero,
                categoriaId,
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
            }
        );

        return data;
    }

    async ignorarFonte({
        numero,
        orgaoId,
    }: {
        numero: string;
        orgaoId: number;
    }): Promise<void> {
        await axios.post(
            `${GATEWAY_API_URL}/saldo-empenhos/fonte/a-ignorar`,
            {
                numero,
                orgaoId,
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
            }
        );
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FontesACadastrarService();
